import {setApiClient} from '../api/domain.js'
import {genericApi} from '../api/modules/basic-api.js'

export default {
  // ----------------------global event handle func start -----------------------
  handleKeyUp: function (event) {
    if (event.which === 27) {
      if (this.OpenedModalStack.length > 0) {
        // this.$bus.$emit('modal-force-close', this.OpenedModalStack[this.OpenedModalStack.length - 1])
      }
    }
    if (event.which === 13) {
      this.$bus.$emit('modal-force-close')
    }
  },
  getRole: function () {
    
    if (window.location.hash.startsWith('#merchantreset') ) {
      return "merchant_empty"
    }
    else {
      return "merchant"
    }
    // return "spalogin"
  },
  getApiParam: function (role, paramBody) {
    setApiClient(role,paramBody)
    if (this.$bus.session &&
        this.$bus.session.hasOwnProperty('user_id') &&
        this.$bus.session.hasOwnProperty('token')) {
      if (role === this.getRole()) {
        paramBody.uinqueuid = this.session.user_id
        paramBody.session_token = this.session.token
      }
      else {
        // 指定特定的role就要抓特定localStorage的值來當user_id與token(for後台模擬操作)
        const session_key =  role + '_session'
        if (role == 'merchant' || role == 'user') {
          // const session_key =  'merchant_session'
          const session_raw = window.localStorage.getItem(session_key)
          if (session_raw && session_raw != 'undefined') {
            const custom_session = JSON.parse(session_raw)
            paramBody.uinqueuid = custom_session.user_id
            paramBody.session_token = custom_session.token
          }
        }
        else if (role == 'merchant_empty') {
          //get不用傳參數
        }
        else if (role == 'nineder'){
          // 由後端移除掉必要id/token
          // paramBody.uinqueuid = -1
          // paramBody.session = 'not needed'
        }
        else if (role == 'trial') {
          // 暫時先寫死
          paramBody.uinqueuid = 1
          paramBody.session_token = 'FQNTGYK6VFYAF7SQTSZJOEVZZMBS3DPH'
        }
      }
    }
    if (role !== 'trial' && role !== 'nineder' && role !== 'merchant_empty' && ((!paramBody.hasOwnProperty('uinqueuid') || !paramBody.hasOwnProperty('session_token') || !paramBody.session_token ))) {
      if (
        paramBody.method !== 'user_login' &&
        paramBody.method !== 'user_verify_login' &&
        paramBody.method !== 'merchant_login' &&
        paramBody.method !== 'bindLineLogin' &&
        paramBody.method !== 'admin_login'  
      ) {
        return undefined
      }
    }
    return paramBody
  },
  apiCall: function (Param,callback, vm) {
    let role = this.getRole()
    if (Param.hasOwnProperty('role')) {
      role = Param.role
    }
    //Param = vm.$bus.getApiParam(role, Param)
    Param = this.getApiParam(role, Param)
    if (Param === undefined) {
      // 有使用載入中組件並在api呼叫時設定者,只可以是Loading下的show控制顯示,否則無法在參數異常時隱藏
      if (vm.Loading && vm.Loading.show) {
        vm.Loading.show = false
      }
      vm.$bus.fnShowInfo('請先登入',true,function () {
        // 在這裡無法存取由index hook進$bus的global方法  
        vm.$bus.session = null
      })
      return
    }
    // 不需要複雜的重複寫死if結構
    if (Param.newapi) {
      Param.apiTarget = 'trial'
    }
    genericApi(Param).then(data => {
      // 只做一個額外處理,就是判斷需要重新登入時,把session_token幹掉,別卡死不能動
      if (!data.ok  && data.data && data.data.session_invalid) {
        // 要重新登入
        //有註冊showInfo與close info popup時就直接用
        // 嚴格說來這是耦合設計,不過global-data有定義了
        if (this.fnShowInfo && this.fnClosePopup) {
          this.fnShowInfo(data.msg, false, () => {
            this.fnClosePopup()
            this.session = null;
            const session_key = this.getRole() + '_session'
            window.localStorage.removeItem(session_key)
          })
        }
        else {
          // 若主要組件沒提供fnShowInfo等方法的hook回呼實作,就只清session讓監聽session為null的地方把login叫出來就好
          this.$bus.session = null;
          const session_key = this.$bus.getRole() + '_session'
          window.localStorage.removeItem(session_key)
        }
      }
      callback(data, vm)
    }, reject => {
      // 抄來的語法未充分測試,應該不會進來
      let ex = {
        'ok':0,
        'code':500,
        'msg':'network error'+JSON.stringify(reject)
      }
      callback(ex,vm)
    })
    return
  },
  setHookCallback(hook, callback) {
    this.$bus[hook] = callback
  },
  createErrorCode: function(page_name){
    return 'TKV' + (Array(5).join('0') + this.$bus.pageCodeMapper[page_name].code).slice(-5)
  },
  getYYYYMMDD: function (date, symbol){
    let date_format = ''

    date_format += date.getFullYear().toString() + symbol
    if (date.getMonth() + 1 < 10) {
        date_format += '0'
    }
    date_format += (date.getMonth() + 1).toString() + symbol

    if (date.getDate() < 10) {
        date_format += '0'
    }
    date_format += date.getDate().toString()
    return date_format
},
  setHookCallback(hook, callback) {
    this.$bus[hook] = callback
  },
  /**
   * 
   * @param {*} value 
   * @returns {Boolean}
   */
  checkInputValueIsNumber(value) {
    const regex = new RegExp(/^\d+$/);
    let Number = regex.test(value);
    return Number;
  }
  // ----------------------global event handle func end -------------------------
  // ----------------------global utility function start ------------------------
  // ...stateless generic function all move to mixins to prevent duplicate
  // ----------------------global utility function end --------------------------
}
